/* eslint-disable prettier/prettier */
import React from 'react';
import {useSeasons} from "../../../hooks/seasons";
import {useTeamFilterOptions} from "../FilterOptions/TeamFilterOptions";

function TeamsFilter({ setSeason, season, orderBy, setOrderBy }) {
    const [seasons, loadingSeasons, errorSeasons] = useSeasons('desc');
    const [teamFilterOptions, loadingTeamFilterOptions, errorTeamFilterOptions] = useTeamFilterOptions();
    return (
        <div className="data-container__header">
            <div className="row px-4 pt-3 pb-2">
                <div className="col-12 col-md-3 pe-md-1 mb-3 mb-md-0">
                    <p className="heading-h6 mb-1">Sorterat på</p>
                    <select
                        value={orderBy}
                        onChange={(e) => setOrderBy(e.target.value)}
                        className="select"
                    >
                        {teamFilterOptions?.map((option) => (
                            <option value={option?.key}>{option?.name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md-3 pe-md-1 mb-3 mb-md-0">
                    <p className="heading-h6 mb-1">Säsong</p>
                    <select
                        value={season}
                        onChange={(e) => setSeason(e.target.value)}
                        className="select"
                    >
                        {seasons?.map((season) => (
                            (Number(season?.configSeasonStartYear) >= 2019) ?
                                <option value={season?.configSeasonStartYear}>{season?.configSeasonStartYear}</option> :
                                ''
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
}
export default TeamsFilter;